import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'

export enum Inv3510Status {
  Draft = 1,
  Scheduled = 2,
  InProgress = 3,
  PendingVarianceReview = 4,
  PendingAdjustment = 5,
  Completed = 6,
  Cancelled = 7,
}

export const Inv3510StatusSchema = z.nativeEnum(Inv3510Status)

export const Inv3510SearchParamsSchema = z
  .object({
    keyword: z.string().optional(),
    status: z.coerce.number().pipe(Inv3510StatusSchema).optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv3510SearchParams = z.infer<typeof Inv3510SearchParamsSchema>

export const Inv3510SearchResultModelSchema = z.object({
  id: z.string(), // UUID
  number: z.string(),
  description: z.string(),
  scheduledDate: z.coerce.date(),
  status: Inv3510StatusSchema,
  zoneCount: z.number(),
  completedZoneCount: z.number(),
  startedAt: z.coerce.date().nullable(),
  completedAt: z.coerce.date().nullable(),
})

export type Inv3510SearchResultModel = z.infer<
  typeof Inv3510SearchResultModelSchema
>

export const Inv3510SearchResultSchema = z
  .object({
    data: z.array(Inv3510SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv3510SearchResult = z.infer<typeof Inv3510SearchResultSchema>
